// eyeq — GET /api/eyeq/health (public liveness probe).
import { z } from 'zod';

export const EyeqHealthResSchema = z.object({
  ok: z.literal(true),
  project: z.literal('eyeq'),
  ts: z.string(),
});
export type EyeqHealthRes = z.infer<typeof EyeqHealthResSchema>;
